/**
 * @generated SignedSource<<cb5dec3c778187f3b0122a8dde29f97b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksInlinePlusWidgetContent$data = {
  readonly topics: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "hooksInlinePlusWidgetContent";
};
export type hooksInlinePlusWidgetContent$key = {
  readonly " $data"?: hooksInlinePlusWidgetContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksInlinePlusWidgetContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksInlinePlusWidgetContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "7134bd8e8073d1a9f1b132f4c61c33d5";

export default node;
